import { ApiClient } from "@modules/core/api/client/apiClient"
import { ExploreProgramBundleItemDto, ExploreProgramBundleItemDtoSchema } from "@modules/explore/gateway/exploreDto"
import { ProgramBundleApiGateway } from "@modules/programBundle/api/programBundleApiGateway"
import {
  ProgramBundleDraftDto,
  ProgramBundleDto,
  ProgramBundleDtoSchema,
  ProgramBundleType,
} from "@modules/programBundle/api/programBundleDto"

export class ProgramBundleApi implements ProgramBundleApiGateway {
  private baseUrl = "/program-bundles"

  constructor(private api: ApiClient) {}

  async getProgramBundle(programBundleId: string): Promise<ProgramBundleDto> {
    const result = await this.api.get<ProgramBundleDto>(`${this.baseUrl}/${programBundleId}`)

    return ProgramBundleDtoSchema.parse(result.data)
  }

  // Use null for filter to get all program bundles
  async getProgramBundles(filter: ProgramBundleType | null, onlyWithPrice: boolean): Promise<ProgramBundleDto[]> {
    const resultDto = await this.api.get<ProgramBundleDto[]>(`${this.baseUrl}`, {
      params: { filter, onlyWithPrice },
    })
    return resultDto.data.map((programBundleDto) => ProgramBundleDtoSchema.parse(programBundleDto))
  }

  async getProgramBundlesSubscribed(): Promise<ExploreProgramBundleItemDto[]> {
    const resultDto = await this.api.get<ExploreProgramBundleItemDto[]>(`${this.baseUrl}/subscribed`)
    return resultDto.data.map((programBundle) => ExploreProgramBundleItemDtoSchema.parse(programBundle))
  }

  async createProgramBundle(programBundleDraft: ProgramBundleDraftDto): Promise<ProgramBundleDto> {
    const response = await this.api.post<void>(`${this.baseUrl}`, programBundleDraft)
    return ProgramBundleDtoSchema.parse(response.data)
  }

  async updateProgramBundle(programBundleId: string, programBundleDraft: ProgramBundleDraftDto): Promise<void> {
    await this.api.put<void>(`${this.baseUrl}/${programBundleId}`, programBundleDraft)
  }

  async deleteProgramBundle(programBundleId: string): Promise<void> {
    await this.api.delete<void>(`${this.baseUrl}/${programBundleId}`)
  }
}
